export const TRIAL_EXPIRED_LOGIN_MODAL_KEY = 'showTrialExpiredLoginModal';
export const BILLING_UPGRADE_EVENT = 'jobscribe:billing-upgrade-required';
export const TRIAL_NOT_STARTED_EVENT = 'jobscribe:trial-not-started';

/**
 * Paths still reachable while access_mode is billing_only.
 * Company staff cannot use Plan & Billing, so /billing is only allowed for the company admin account.
 *
 * @param {string} pathname
 * @param {{ canAccessBilling?: boolean }} [options]
 * @returns {boolean}
 */
export function isBillingOnlyAllowedPath(pathname, options = {}) {
  const canAccessBilling = options.canAccessBilling !== false;

  if (pathname === '/') return true;
  if (canAccessBilling && (pathname === '/billing' || pathname.startsWith('/billing/'))) {
    return true;
  }
  if (pathname.startsWith('/candidate-form')) return true;
  if (pathname.startsWith('/job-fair-form')) return true;
  return false;
}

export function dispatchBillingUpgradeRequired() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(BILLING_UPGRADE_EVENT));
  }
}

export function dispatchTrialNotStarted() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(TRIAL_NOT_STARTED_EVENT));
  }
}
